import Button from "@app/components/button";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import { addToast } from "@app/components/toast/toast.service";
import { SystemMessage } from "@app/constants";
import CommentService from "@app/services/http/comment.service";
import { Images } from "@assets/images";
import { Form, Formik, FormikHelpers } from "formik";
import { useParams } from "react-router-dom";

interface ReplyCommentProps {
  commentId: number;
  onReplyComment: (status: boolean) => void;
  onCancel: () => void;
}

const ReplyComment = ({
  commentId,
  onReplyComment,
  onCancel,
}: ReplyCommentProps) => {
  const { id } = useParams();

  const onSubmit = (
    values: { content: string },
    { setFieldValue }: FormikHelpers<{ content: string }>
  ) => {
    if (!values.content) return;

    CommentService.create({
      bookId: Number(id),
      content: values.content,
      parentId: commentId,
    }).then(() => {
      addToast({ text: SystemMessage.ADD_SUCCESSFULLY });
      setFieldValue("content", "");
      onCancel();
      onReplyComment(true);
    });
  };

  return (
    <div>
      <Formik
        initialValues={{ content: "" }}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <Form>
          <div className="flex items-center justify-around">
            <FormControl name="content">
              <Input
                className="!w-[220px]"
                inputClassName="!bg-[#506079] !h-[40px] !text-white font-[SVN-Gilroy]"
                placeholder="Thêm bình luận"
              />
            </FormControl>
            <Button
              width="auto"
              type="submit"
              className="!w-[60px] ml-2 !h-9 font-bold !text-white "
              label="Đăng"
              labelClassName="text-sm"
            />
            <Button
              label=""
              width={40}
              className=" !bg-transparent !font-bold !text-white"
              icon={Images.CloseIcon.default}
              onClick={onCancel}
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default ReplyComment;
